module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 2
// module chunks = 0 3 4